import * as fabric from 'fabric';

import { useRef, useCallback } from 'react';
import { Canvas } from '../canvas';


const FabricCanvas = ({ layers, screenSize }) => {
    const ref = useRef(null);

    const onLoad = useCallback(
        (canvas) => {
            canvas.setDimensions({
                width: screenSize.width,
                height: screenSize.height,
            });
            if (layers?.length > 0) {
                loadLayers(layers, canvas);
            }
        },
        [ref, layers],
    );

    const applyAdjustments = (img, adjustments = {}) => {
        const {
            brightness = 0,
            contrast = 0,
            saturation = 0,
            blur = 0,
        } = adjustments;

        const f = [];

        if (brightness !== 0) f.push(new fabric.filters.Brightness({ brightness }));
        if (contrast !== 0) f.push(new fabric.filters.Contrast({ contrast }));
        if (saturation !== 0) f.push(new fabric.filters.Saturation({ saturation }));
        if (blur !== 0) f.push(new fabric.filters.Blur({ blur }));

        img.filters = f;
        img.applyFilters();
    };

    const loadLayers = async (layers, canvas) => {
        // canvas.clear();
        console.log('load layers: ', layers.length, canvas)
        const myFabricImageWithLogoPng = await fabric.FabricImage.fromURL(
            layers[0].imageUrl,
            {},
            {
                height: 100
            }
        );
        console.log('myFabricImageWithLogoPng: ', myFabricImageWithLogoPng)

        layers.forEach(async (layer) => {
            const img = await fabric.FabricImage.fromURL(layer.imageUrl);
            console.log('load images: ', layer.imageUrl, img)
            if (!img) return;

            img.set({
                left: layer.x || 0,
                top: layer.y || 0,
                selectable: true,
                hasControls: true,
                id: layer.id,
            });

            img.scaleToWidth(layer.dimensions?.width || 100);
            img.scaleToHeight(layer.dimensions?.height || 100);

            applyAdjustments(img, layer.adjustments);
            canvas.add(img);

            canvas.requestRenderAll();
        });
    };

    return (
        <div className="position-relative">
            <Canvas ref={ref} onLoad={onLoad} />
        </div>
    );
};

export default FabricCanvas;